function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Grid, GridRow, GridCell } from "../";
import { withDefaultMedia } from "../";
export const LegendLogic = ({
  items,
  setRelatedHover,
  onHover,
  direction,
  matches,
  ...props
}) => {
  const [hoveredItem, setHoveredItem] = useState({});
  const total = items.reduce((sum, item) => sum += item.value, 0);
  const modifiedData = items.map(point => {
    return { ...point,
      percentage: point.value / total * 100
    };
  });
  useEffect(() => {
    if (!!setRelatedHover) {
      setHoveredItem(setRelatedHover);
    } else {
      setHoveredItem({});
    }
  }, [setRelatedHover]);

  const handleMouseOver = item => {
    setHoveredItem(item);
    onHover(item);
  };

  const handleMouseLeave = () => {
    setHoveredItem({});
    onHover({});
  };

  return React.createElement(Grid, _extends({
    column: true
  }, props), modifiedData.map((item, index) => {
    const {
      label,
      value,
      percentage,
      id
    } = item;
    return React.createElement(LegendItem, {
      key: id,
      onMouseEnter: () => handleMouseOver(item),
      onMouseLeave: handleMouseLeave,
      hover: id == hoveredItem.id,
      layout: direction
    }, React.createElement(CellLabel, {
      stretch: true,
      layout: direction,
      columns: !matches.large ? 2 : direction === "row" ? 4 : 2
    }, React.createElement(LegendIcon, {
      index: index
    }), React.createElement(Ellipses, null, label)), !!value && direction === "row" && React.createElement(CellValue, {
      xEnd: true,
      columns: 1
    }, value), !!percentage && React.createElement(CellPercentage, {
      xEnd: true,
      columns: 1
    }, Math.round(percentage), "%"));
  }));
};
export const Legend = withDefaultMedia(LegendLogic);
const LegendItem = styled(GridRow)`
${props => props.layout === "column" ? `border-bottom: none;` : `border-bottom: 1px solid ${props.theme.colors.borderLight};`};
  box-sizing: border-box;
  cursor: default;
  &:hover {
    background-color: #f5f5f5;
  }
  ${props => props.hover && "background-color: #F5F5F5;"}
  height: ${props => props.layout === "column" ? "40px" : "56px"};
`;
const LegendIcon = styled.div`
  border-radius: 50%;
  height: 16px;
  width: 16px;
  min-width: 16px;
  margin-right: 8px;
  background-color: ${props => props.theme.charts[props.index % props.theme.charts.length]};
`;
const Ellipses = styled.div`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const CellLabel = styled(GridCell)`
  font-weight: 600;
  padding-left: 0;

  @media only screen and ${props => props.theme.media.large} {
    font-weight: ${props => props.layout === "row" ? "600" : "400"};
  }
`;
const CellValue = styled(GridCell)`
  font-weight: 400;
`;
const CellPercentage = styled(GridCell)`
  color: #596266;
`;